import { render, staticRenderFns } from "./LoginInDemo.vue?vue&type=template&id=0af8356d&scoped=true"
import script from "./LoginInDemo.vue?vue&type=script&lang=js"
export * from "./LoginInDemo.vue?vue&type=script&lang=js"
import style0 from "./LoginInDemo.vue?vue&type=style&index=0&id=0af8356d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af8356d",
  null
  
)

export default component.exports